const DEFAULT_SIZE = 100;
const count = iterable => {
  return iterable.size != null ? iterable.size : iterable.length;
};
const range = size => [...Array(size)].map((_, i) => i);
const chunk = (list, size) => range(Math.ceil(count(list) / size)).map(index => list.slice(index * size, size * (index + 1)));
export default ((callback, reducer, list, size = DEFAULT_SIZE) => Promise.all(chunk(list, size).map(callback)).then(reducer));